var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.bg),attrs:{"id":"app"}},[(_vm.isTopNavAlive)?_c('topnav',{staticClass:"app_topnav"}):_vm._e(),_c('router-view',{staticClass:"app_routerview"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }